import { Box, SearchField } from '@factorialco/deprecated-design-system'

import Select from 'modules/core/components/Select'
import i18n from 'modules/core/lib/i18n'

import { usePayrollResultFilterContext } from 'modules/bookkeepers/hooks/PayrollResultContext'
import { PayrollStatus } from 'modules/payroll_bundle/lib/enums'

const statusOptions = () => [
  {
    value: PayrollStatus.PAYROLL_CALCULATION,
    label: i18n.t('bookkeepers.clients.payroll_periods.payroll_calculation'),
  },
  {
    value: [
      PayrollStatus.PREPARATION,
      PayrollStatus.SUPPLEMENTS_DEFINITION,
      PayrollStatus.UNDER_REVIEW,
    ],
    label: i18n.t('bookkeepers.clients.payroll_periods.defining_supplements'),
  },
  {
    value: [PayrollStatus.PAYMENT_PROCESSING, PayrollStatus.PAID],
    label: i18n.t('bookkeepers.clients.payroll_periods.payment'),
  },
]

const PayrollResultsFilter = () => {
  const { status, onStatusChange, search, onSearch } = usePayrollResultFilterContext()

  return (
    <Box width="full" flexDirection="row" alignSelf="flexEnd" gap="s12">
      <Box>
        <Select
          options={statusOptions()}
          value={status}
          onChange={(value: string) => onStatusChange(value)}
        />
      </Box>

      <Box width="full">
        <SearchField
          variant="big"
          placeholder={i18n.t('bookkeepers.clients.payroll_dashboard.search.title')}
          search={search}
          onSearch={onSearch}
        />
      </Box>
    </Box>
  )
}

export default PayrollResultsFilter
